import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { messages } from "./languages";

i18n
	.use(LanguageDetector)
	.init({
		debug: false,
		lng: "pt",
		fallbackLng: "pt",
		defaultNS: "translations",
		ns: ["translations"],
		resources: messages,
		interpolation: {
			escapeValue: false
		}
	});

export { i18n };
